module.exports = {
  src: __webpack_public_path__ + "assets/images/headerLogoDark.015175e30264ddd9.svg",
  width: 111,
  height: 33,
  toString: function() { return __webpack_public_path__ + "assets/images/headerLogoDark.015175e30264ddd9.svg"; }
};